import { render, staticRenderFns } from "./modal-tnc.vue?vue&type=template&id=21b131e3"
import script from "./modal-tnc.vue?vue&type=script&lang=js"
export * from "./modal-tnc.vue?vue&type=script&lang=js"
import style0 from "./modal-tnc.vue?vue&type=style&index=0&id=21b131e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports